/**
 * „Als Gast ansehen“ (P21): Die Projektleitung öffnet ein Projekt mit `?als=<Gast-ID>` in einem eigenen Tab. Dieser
 * Tab schickt bei jeder Anfrage `x-werft-als`; der Server antwortet mit der Sicht des Gastes und lehnt Änderungen ab.
 * Ohne Live-Abgleich und ohne Offline-Speicher – sonst landete die Gast-Sicht im Zwischenspeicher der Leitung.
 */
export interface Preview {
  projectId: string;
  userId: string;
}

const KEY = 'werft.als';
let current: Preview | null = null;

function read(): Preview | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as Preview) : null;
  } catch {
    return null;
  }
}

/** Beim Start: `?als=` aus der Adresse übernehmen (und aus der Adresse entfernen) */
export function initPreview() {
  current = read();
  const url = new URL(location.href);
  const als = url.searchParams.get('als');
  const m = /^\/p\/([0-9a-f-]{36})/.exec(url.pathname);
  if (als && m && (/^[A-Za-z0-9_-]{1,100}$/.test(als) || /^~scope:(view|comment|edit):[01]:[0-9a-f,-]{0,800}$/.test(als))) {
    current = { projectId: m[1]!, userId: als };
    try {
      sessionStorage.setItem(KEY, JSON.stringify(current));
    } catch {
      /* gilt dann nur bis zum Neuladen */
    }
    url.searchParams.delete('als');
    history.replaceState(history.state, '', url);
  }
}

export const preview = () => current;

export function endPreview(projectId: string) {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* egal */
  }
  current = null;
  window.close();
  // Wenn der Tab sich nicht schließen lässt: normale Ansicht laden
  location.href = `/p/${projectId}`;
}

/** W09: Vorschau mit geplantem Umfang (noch niemand eingeladen) – dieselbe Rechnung wie für einen echten Gast */
export function plannedPreviewId(access: string, whole: boolean, areaIds: string[]) {
  return `~scope:${access}:${whole ? 1 : 0}:${whole ? '' : areaIds.join(',')}`;
}
export const isPlanned = (userId: string) => userId.startsWith('~scope:');
